@for (key of websitesKeys; track $index) {
  @if (!!log && hasLog(key, log)) {
    <div
      [innerHTML]="normalizeLog(key, log) | changeLogsDiffHTML: websitesLookup : (getLookup(key) | async)"
    ></div>
  }
}

